import api from './ApiManager';

// This service provides functions to check and manage JWT tokens

export function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
}

export const isTokenValid = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return false;
  }

  try {
    await api.get('/api/auth/me');
    return true;
  } catch (error) {
    // If token is invalid, clear it
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    return false;
  }
};

// Clear stored tokens
export function clearTokens() {
  localStorage.removeItem('token');
  localStorage.removeItem('userData');
  // Dispatch custom event to notify authentication state change
  window.dispatchEvent(new Event('authChange'));
}
